module.exports = __webpack_public_path__ + "static/media/hairdresser-min.434d460a.png";